import { environmentData } from "@/helper/environment";
import { useEquipmentLocationStore } from "@/store/history/equipment_location_store";
import { useEquipmentSearchIdsStore } from "@/store/history/equipment_id_store";
import { EquipmentHistoryServices } from "@/service/history/equipment_event_history_service";
import { ContainerEventHistoryInterface } from "@/interface/history/equipment_history_interface";
import { storeToRefs } from "pinia";

export class EquipmentHistoryRepository {
  async getEquipmentHistroy(): Promise<ContainerEventHistoryInterface> {
    const service = new EquipmentHistoryServices();
    const searchStore = useEquipmentSearchIdsStore();
    const locationStore = useEquipmentLocationStore();
    const terminalId = locationStore.terminalSelected.id;
    // Fetch the import assets based on the search ids
    const { equipmentSearchIds } = storeToRefs(searchStore);
    const ids = equipmentSearchIds.value.join(",");

    const url = `${environmentData.domain}/tt-container-events?containerIds=${ids}&terminal=${terminalId}`;
    const containers: ContainerEventHistoryInterface = await service.fetchHistory(url);

    // Loop through validIds
    let idCounter = 1; // Start ID counter
    containers.validIds?.forEach((validId) => {
      // Loop through containerEventDetails within each validId
      validId.containerEventDetails?.forEach((event) => {
        event.id = idCounter++; // Assign a unique ID
      });
    });
    return containers;
  }
}
